import {createImgIn, createLinkIn, createSpanIn, setElementInnerHTML} from '../../../../shared/scripts/ui_utils/DomUtils'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'
import {UIAjaxWrapper} from '../../../../shared/scripts/network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../../../../shared/scripts/network/UIAPIEndpoints'

export class UIMainPageOverviewController {
    private overview: AjaxDataTypes.PublicProfileDataOverview

    constructor() {
        ClientUserState.registerChangeListener(() => {
            void this.loadData()
        })
    }

    private async loadData() {
        await this.setOverview()
        this.setOverviewCards()
    }

    private async setOverview() {
        if(ClientUserState.userState == undefined) return
        if(this.overview?.userId == ClientUserState.userState.id) return

        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiHomepageProfileOverview(), undefined)
        if(response == undefined) return

        const overview = response.json as AjaxDataTypes.PublicProfileDataOverview
        if(overview.userId != ClientUserState.userState.id) return

        this.overview = overview
    }

    private setOverviewCards() {
        if(this.overview == undefined) return
        this.setTotalGamesStat()
        this.setWinLossStat()
        this.setWinRateStat()
        this.setKarmaStat()
        this.setMembershipStat()
        this.setPointsStat()
    }

    private setWinLossStat() {
        const winLossStatValue = `${this.overview.gameData.winsInLast100Games}/${this.overview.gameData.totalGames < 100 ? this.overview.gameData.totalGames : 100}`
        const statSpanId = 'mainpage_overview_card_wins'
        const statSpan = document.getElementById(statSpanId) as HTMLElement
        setElementInnerHTML(statSpan, {key: 'strings:colonistCommon.utils.#buffer', options: {value: winLossStatValue}})
    }

    private setWinRateStat() {
        const winRateStatValue = this.overview.gameData.winPercent
        const statSpanId = 'mainpage_overview_card_winRate'
        const statSpan = document.getElementById(statSpanId) as HTMLElement
        setElementInnerHTML(statSpan, {key: 'strings:colonistCommon.utils.#buffer', options: {value: winRateStatValue}})
    }

    private setKarmaStat() {
        const karmaStatValue = this.overview.karma
        const statSpanId = 'mainpage_overview_card_karma'
        const statSpan = document.getElementById(statSpanId) as HTMLElement
        setElementInnerHTML(statSpan, {key: 'strings:colonistCommon.utils.#buffer', options: {value: karmaStatValue}})
    }

    private setPointsStat() {
        const pointsStatValue = this.overview.gameData.pointsInLast100Games.toString()
        const statSpanId = 'mainpage_overview_card_points'
        const statSpan = document.getElementById(statSpanId) as HTMLElement
        setElementInnerHTML(statSpan, {key: 'strings:colonistCommon.utils.#buffer', options: {value: pointsStatValue}})
    }

    private setTotalGamesStat() {
        const totalGamesStatValue = this.overview.gameData.totalGames.toString()
        const statSpanId = 'mainpage_overview_card_games'
        const statSpan = document.getElementById(statSpanId) as HTMLElement
        setElementInnerHTML(statSpan, {key: 'strings:colonistCommon.utils.#buffer', options: {value: totalGamesStatValue}})
    }

    // eslint-disable-next-line class-methods-use-this
    private setMembershipStat() {
        const statSpan = document.getElementById('mainpage_overview_card_membership') as HTMLElement
        const currentMembership = ClientUserState.userState?.items.getCurrentMembership()
        if(currentMembership) {
            setElementInnerHTML(statSpan, {key: 'strings:colonistCommon.utils.emptyString'})
            createImgIn(statSpan, currentMembership.image)
            createSpanIn(statSpan, '', currentMembership.title)
        } else {
            setElementInnerHTML(statSpan, {key: 'strings:colonistCommon.utils.emptyString'})
            createLinkIn(statSpan, '/store#membership', {key: 'strings:homePage.becomeAMember'}, '')
        }
    }
}
